export default __webpack_public_path__ + "static/media/wood_break2.67ede8f2.ogg";